var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"600px","frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }